var map = {
	"./black-rock.png": 1834,
	"./blue-rock.png": 1730,
	"./brown-rock.png": 3658,
	"./darkwhite-rock.png": 8434,
	"./green-rock.png": 8670,
	"./lightbrown-rock.png": 6507,
	"./white-rock.png": 7337,
	"./yellow-rock.png": 9826
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1865;